import React from 'react';
import { Outlet } from 'react-router-dom';
import STC from '../../../STCLibrary/STCFactory/STCFactory';
import './Admin.css'

export default function Admin(){

    return(
        <div>
            <div className='admin-header'><STC.Logo.Long/> <h3>Admin</h3></div>
            
            <Outlet/>
        </div>
    )
}